import {Component, Inject} from '@angular/core';
import { AuthService } from '../core/auth.service';
import { Router, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {UserService} from '../core/user.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {
  keyword = 'firedept$';
  unlocked = false;
  registerForm: FormGroup;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(
    @Inject(AuthService) private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.createForm();
   }

   createForm() {
     this.registerForm = this.fb.group({
       firstName: ['', Validators.required],
       lastName: ['', Validators.required],
       payroll: ['', Validators.required],
       confirmPayroll: ['', Validators.required],
       email: ['', Validators.required ],
       password: ['', Validators.required],
       confirmPassword: ['', Validators.required]
     });
   }

   tryRegister(value) {
      if (!value.firstName || !value.lastName || !value.payroll || !value.email || !value.password) {
        this.errorMessage = 'Please fill out ALL required fields.';
        return;
      }
      if (value.password !== value.confirmPassword) {
        this.errorMessage = 'Please make sure the passwords match.';
        return;
      }
      if (value.payroll !== value.confirmPayroll) {
        this.errorMessage = 'Please make sure the payroll numbers match.';
        return;
      }
      console.log(value);
      this.authService.doRegister(value)
      .then(res => {
        console.log(res);
        this.errorMessage = '';
        this.successMessage = 'Your account has been created. You may now log in.';
      }, err => {
        console.log(err);
        this.errorMessage = err.message;
        this.successMessage = '';
      });
   }

   authorizeKeyword(event) {
      if (event.target.value === this.keyword) {
        this.unlocked = true;
      }
   }
}
